import React from 'react';
import { useTranslation } from 'react-i18next';
import { Form, Modal, Select } from 'antd';
import debounce from 'lodash.debounce';
import { useUpdateInvoiceStatus } from 'api/invoices/use-update-invoice-status';
import type { IInvoiceStatusEditModalProps, IInvoiceStatusFormFields } from './types';
import { usePreparedStatuses } from './use-prepared-statuses';

export const InvoiceStatusEditModal: React.FC<IInvoiceStatusEditModalProps> = (props) => {
  const { isOpen, onClose, currentStatus, invoiceId } = props;
  const { t } = useTranslation('invoice');

  const preparedStatuses = usePreparedStatuses(currentStatus);

  const { mutateAsync: updateInvoiceStatus, isLoading } = useUpdateInvoiceStatus(invoiceId);

  const [form] = Form.useForm();
  const handleOk = debounce(() => form.submit(), 200);

  const onFinish = async (values: IInvoiceStatusFormFields) => {
    await updateInvoiceStatus(values);
    onClose();
  };

  return (
    <Modal title={t('edit_status')} open={isOpen} confirmLoading={isLoading} onCancel={onClose} onOk={handleOk}>
      <Form
        form={form}
        name='financial_status'
        layout='vertical'
        initialValues={currentStatus ? { status: currentStatus } : undefined}
        onFinish={onFinish}>
        <Form.Item name='status' rules={[{ required: true, type: 'string' }]}>
          <Select options={preparedStatuses} />
        </Form.Item>
      </Form>
    </Modal>
  );
};
